export const Page404 = () => {
    return (
        <div>
            Page Not Found
            <br></br>
            <a href="https://www.crematrix.com/">Go back to Home Page</a>
        </div>
    )
}